import { ITracker } from 'models/tracker';

import { api } from '..';
import { AddTracker, EditTracker, FetchTrackers, IAddLanding, IGetLanding } from './trackers';
import { FetchWithPagination } from '../common';

export const trackersApi = api.injectEndpoints({
  endpoints: (build) => ({
    fetchAllTrackers: build.query<FetchWithPagination<ITracker[]>, FetchTrackers>({
      query: ({ ...params }) => ({
        url: '/trackers',
        params,
      }),
      providesTags: ['Trackers'],
    }),
    addTrackers: build.mutation<void, AddTracker>({
      query: (body) => ({
        url: '/trackers',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Trackers'],
    }),
    getLanding: build.query<IGetLanding, IAddLanding>({
      query: ({ id }) => ({
        url: `/trackers/${id}/groups`,
      }),
      providesTags: ['Trackers'],
    }),
    updateTrackers: build.mutation<void, Partial<EditTracker>>({
      query: ({ id, ...body }) => ({
        url: `/trackers/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Trackers'],
    }),
  }),
});
